import React from "react";
import { snakeToTitleKebab, toSnakeCase } from "./utils/StringFormatters";

const StatusTag = ({ status, type }) => {
  const statusColors = {
    submission: {
      processing: "purple",
      complete: "green",
    },
    claim: {
      conforming: "blue",
      non_conforming: "red",
    },
  };

  return (
    <div className="status_tag__container">
      <div
        className={`status_tag__indicator status_tag__indicator--${statusColors[type][toSnakeCase(status)]}`}
      ></div>
      <div className="t--sm t--nowrap">{snakeToTitleKebab(status)}</div>
    </div>
  );
};

export default StatusTag;
